import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelpButtonPositionerService {
  private _defaultInsetEnd = 20;
  readonly #insetEnd = signal<number>(this._defaultInsetEnd);
  readonly insetEnd = this.#insetEnd.asReadonly();

  stack: number[] = [];

  get lastItemIndex() {
    return this.stack.length - 1;
  }

  get defaultInsetEnd() {
    return this._defaultInsetEnd;
  }

  set defaultInsetEnd(insetEnd: number) {
    this._defaultInsetEnd = insetEnd;
  }

  register(elementId: number | null, width: number): number {
    if (elementId === null) {
      this.stack.push(width);
      elementId = this.lastItemIndex;
      this.stack[elementId] = width;
    } else if (elementId === this.lastItemIndex) {
      this.stack[elementId] = width;
    } else {
      this.stack = this.stack.filter((_, i) => i !== elementId);
      this.stack.push(width);
      elementId = this.lastItemIndex;
    }

    this.#insetEnd.set(width + this._defaultInsetEnd);
    return elementId;
  }

  pop(elementId: number) {
    if (elementId === null) {
      return;
    }

    this.stack = this.stack.filter((_, i) => i !== elementId);
    const newWidth =
      this.stack.length > 0
        ? this.stack[this.lastItemIndex] + this._defaultInsetEnd
        : this._defaultInsetEnd;

    this.#insetEnd.set(newWidth);
  }
}
